const password = "e51fe9b2deff49620a0aae85828d5a6017cb1890f28f36d07ecd2d823e0fc88f";

function _getDateNow() {
    // Obter o timestamp atual
    const timestampNow = Date.now();

    // Criar um objeto Date com o timestamp atual
    const dateNow = new Date(timestampNow);

    // Configurar o objeto Date para o fuso horário do Brasil (horário de Brasília)
    dateNow.toLocaleString('en-US', { timeZone: 'America/Sao_Paulo' });

    // Obter o timestamp do objeto Date configurado para o fuso horário do Brasil unix timestamp
    const brazilTimestamp = dateNow.getTime();

    return brazilTimestamp / 1000;
}

export function EncryptToBase64WithPassword(data) {

    const brazilTimestamp = _getDateNow();

    // Add timestamp to data
    data["timestamp"] = brazilTimestamp + 1800; // 30 minutos

    const text = JSON.stringify(data);

    let encrypted = '';
    for (let i = 0; i < text.length; i++) {
        encrypted += String.fromCharCode(text.charCodeAt(i) ^ password.charCodeAt(i % password.length));
    }
    return btoa(encrypted);
}

export function DecryptFromBase64WithPassword(encrypted) {
    // Decodifica o Base64 para bytes
    let decoded = atob(encrypted);

    // Converte para um array de bytes para processar corretamente UTF-8
    let bytes = new Uint8Array(decoded.length);
    for (let i = 0; i < decoded.length; i++) {
        bytes[i] = decoded.charCodeAt(i);
    }

    // Decriptografa os bytes usando a senha
    let decryptedBytes = new Uint8Array(bytes.length);
    for (let i = 0; i < bytes.length; i++) {
        decryptedBytes[i] = bytes[i] ^ password.charCodeAt(i % password.length);
    }

    // Converte os bytes de volta para uma string UTF-8
    let decoder = new TextDecoder('utf-8');
    let decrypted = decoder.decode(decryptedBytes);

    // Remove aspas duplas no início e no fim, se houver
    decrypted = decrypted.replace(/^"(.*)"$/, '$1');

    // Analisa o JSON
    const jsonData = JSON.parse(decrypted);

    // Obtém o timestamp atual no Brasil
    const brazilTimestampNow = _getDateNow();

    // Valida o timestamp
    const timestampValidate = jsonData["timestamp"];
    if (timestampValidate >= brazilTimestampNow) {
        return jsonData;
    }

    return null;
}

// export function DecryptFromBase64WithPassword(encrypted) {
//     let decoded = atob(encrypted);
//     let decrypted = '';
//     for (let i = 0; i < decoded.length; i++) {
//         decrypted += String.fromCharCode(decoded.charCodeAt(i) ^ password.charCodeAt(i % password.length));
//     }
//     decrypted = decrypted.replace(/^"(.*)"$/, '$1'); // Remove as aspas duplas no início e no fim

//     const jsonData = JSON.parse(decrypted);

//     const brazilTimestampNow = _getDateNow();

//     // Get timestamp
//     const timestampValidate = jsonData["timestamp"];

//     if (timestampValidate >= brazilTimestampNow) {
//         return jsonData;
//     }

//     return null;
// }
// 1712676599
//1712676576.16
